const VIEW_MODES = {
  TABLE: 'table',
  VISUAL: 'visual',
};

const VIEW_MODE_DISPLAY = {
  [VIEW_MODES.TABLE]: {
    label: 'Table view',
    icon: '≡',
  },
  [VIEW_MODES.VISUAL]: {
    label: 'Grid view',
    icon: '⊞',
  },
};

const VIEW_MODE_STORAGE_MAP = {
  list: VIEW_MODES.TABLE,
  grid: VIEW_MODES.VISUAL,
  [VIEW_MODES.TABLE]: 'list',
  [VIEW_MODES.VISUAL]: 'grid',
};

export { VIEW_MODES, VIEW_MODE_DISPLAY, VIEW_MODE_STORAGE_MAP };
